import React from "react";
import { Mail, MapPin, Phone, ShieldCheck, ArrowRight, Facebook, Linkedin, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading,
    error
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-5 w-24 bg-muted/10 animate-pulse rounded" />)}
      </div>;
  }
  if (error) {
    return <div className="text-sm text-destructive">Unable to load menu.</div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}><Link to="/AboutUsPage" className="text-muted-foreground hover:text-primary transition-colors text-sm">About Us</Link></li>
        <li data-index={1}><Link to="/OurModelPage" className="text-muted-foreground hover:text-primary transition-colors text-sm">Our Model</Link></li>
        <li data-index={2}><Link to="/ReferralsPage" className="text-muted-foreground hover:text-primary transition-colors text-sm">Referrals</Link></li>
        <li data-index={3}><Link to="/ContactPage" className="text-muted-foreground hover:text-primary transition-colors text-sm">Contact</Link></li>
        <li data-index={4}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm">FAQ</Link></li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-2 group">
            <span className="w-1 h-1 rounded-full bg-primary/40 group-hover:bg-primary transition-colors" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          <div className="space-y-6">
            <Link to="/HomePage" className="block w-fit">
              
            </Link>
            <div className="space-y-4">
              <p className="text-muted-foreground text-sm leading-relaxed">
                Resolve Clinical Services is a South Australia–based NDIS-focused allied health business delivering psychosocial recovery coaching and capacity-building supports.
              </p>
              <div className="text-xs text-muted-foreground/60 space-y-1">
                <p>ACN: 695 534 859</p>
                <p>ABN: 29 695 534 859</p>
                
                <p>Locally Owned & Operated</p>
              </div>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Quick Links</h3>
            <MenuProvider menu_id="18" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Contact Us</h3>
            <ul className="space-y-4">
              
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="w-5 h-5 text-primary shrink-0" />
                <Link to="mailto:info@resolveclinical.com.au" className="hover:text-primary transition-colors">info@resolveclinicalservices.com.au</Link>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="w-5 h-5 text-primary shrink-0" />
                <Link to="tel:+610478046866" className="hover:text-primary transition-colors">
                  +61 0478 046 866
                </Link>
              </li>
            </ul>
            <div className="pt-2">
               <p className="text-xs text-muted-foreground mb-2">Servicing Adelaide & Surrounds</p>
            </div>
          </div>

          {}
          
          
          
        </div>

        <div className="flex justify-center mb-8">
          
        </div>

        <Separator className="bg-border/50" />

        {}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <div className="text-center md:text-left order-2 md:order-1">
            <p>&copy; {currentYear} Resolve Clinical Services Pty Ltd. All rights reserved.</p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-6 order-1 md:order-2">
            <Link to="#" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Sitemap</Link>
          </div>

          <div className="flex gap-4 order-3">
             <Link to="#" aria-label="LinkedIn" className="text-muted-foreground hover:text-primary transition-colors">
                <Linkedin className="w-4 h-4" />
             </Link>
             <Link to="#" aria-label="Facebook" className="text-muted-foreground hover:text-primary transition-colors">
                <Facebook className="w-4 h-4" />
             </Link>
             <Link to="#" aria-label="Instagram" className="text-muted-foreground hover:text-primary transition-colors">
                <Instagram className="w-4 h-4" />
             </Link>
          </div>
        </div>
      </div>
    </section>;
}